// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-edit-exercise {
  padding: 30px;
  background-color: #A5D6A7;
  border-radius: 20px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  width: 90%;
  max-width: 800px;
  margin: 50px auto;
  font-family: 'Rubik', sans-serif;
}

.admin-edit-exercise h1 {
  text-align: center;
  color: #333;
  font-size: 32px;
  margin-bottom: 30px;
  font-weight: 700;
}

.admin-edit-exercise form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.admin-edit-exercise label {
  font-weight: 600;
  color: #333;
  display: block;
  font-family: 'Rubik', sans-serif;
}

.admin-edit-exercise .small-input {
  padding: 12px;
  height: 50px;
  border: 1px solid #ddd;
  border-radius: 15px;
  font-size: 16px;
  font-family: 'Rubik', sans-serif;
  width: 100%;
  box-sizing: border-box;
  background-color: #f9f9f9;
  transition: all 0.3s ease;
}

.admin-edit-exercise .large-input {
  padding: 15px;
  height: 150px;
  border: 1px solid #ddd;
  border-radius: 15px;
  font-size: 16px;
  font-family: 'Rubik', sans-serif;
  width: 100%;
  box-sizing: border-box;
  background-color: #f9f9f9;
  transition: all 0.3s ease;
  resize: vertical;
}

.admin-edit-exercise input:focus,
.admin-edit-exercise textarea:focus {
  border-color: #A5D6A7;
  outline: none;
  background-color: #ffffff;
  box-shadow: 0px 0px 8px rgba(76, 175, 80, 0.5);
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 0px;
  margin-top: 20px;
}

.admin-edit-exercise button {
  background: #004D40;
  color: #fff;
  border: none;
  padding: 12px 20px; 
  border-radius: 15px;
  font-size: 18px; 
  font-family: 'Rubik', sans-serif;
  cursor: pointer;
  font-weight: 600;
  width: 30%;
  min-width: 160px; 
  margin: 0; 
  transition: all 0.3s ease;
  height: 52px; 
  display: flex;
  align-items: center;
  justify-content: center;
}

.admin-edit-exercise button:hover {
  background: #2E7D32;
}

.admin-edit-exercise .cancel-btn3 {
  background: #dc3545;
  color: white;
  width: 30% !important;
  margin-top: 15px;
}

.admin-edit-exercise .cancel-btn3:hover {
  background: #c82333;
}

.success-message-container {
  position: fixed;
  top: 70px;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  pointer-events: none;
}

.success-message15 {
  color: #155724;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  padding: 12px 20px;
  border-radius: 15px;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: inline-flex;
  align-items: center;
  max-width: 60% !important;
  text-align: center;
  animation: fadeInOut 3s ease-in-out forwards;
}

.error-message15 {
  color: #d32f2f;
  background-color: #fde7e9;
  border: 1px solid #d32f2f;
  padding: 12px;
  border-radius: 10px;
  display: flex !important;
  align-items: center !important;
  gap: 8px;
  margin: 10px auto !important; 
  font-weight: 600;
  width: 40%;
  justify-content: center !important;
  text-align: center;
}

@keyframes fadeInOut {
  0% { opacity: 0; transform: translateY(-20px); }
  10% { opacity: 1; transform: translateY(0); }
  90% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-20px); }
}

@media (max-width: 768px) {
  .admin-edit-exercise {
    padding: 20px;
    max-width: 90%;
  }

  .admin-edit-exercise h1 {
    font-size: 24px;
  }

  .button-group {
    flex-direction: column;
  }

  .admin-edit-exercise button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/EditExercisePage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;EACb,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;EACV,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,KAAK,UAAU,EAAE,4BAA4B,EAAE;EAC/C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,OAAO,UAAU,EAAE,4BAA4B,EAAE;AACnD;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".admin-edit-exercise {\n  padding: 30px;\n  background-color: #A5D6A7;\n  border-radius: 20px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n  width: 90%;\n  max-width: 800px;\n  margin: 50px auto;\n  font-family: 'Rubik', sans-serif;\n}\n\n.admin-edit-exercise h1 {\n  text-align: center;\n  color: #333;\n  font-size: 32px;\n  margin-bottom: 30px;\n  font-weight: 700;\n}\n\n.admin-edit-exercise form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.admin-edit-exercise label {\n  font-weight: 600;\n  color: #333;\n  display: block;\n  font-family: 'Rubik', sans-serif;\n}\n\n.admin-edit-exercise .small-input {\n  padding: 12px;\n  height: 50px;\n  border: 1px solid #ddd;\n  border-radius: 15px;\n  font-size: 16px;\n  font-family: 'Rubik', sans-serif;\n  width: 100%;\n  box-sizing: border-box;\n  background-color: #f9f9f9;\n  transition: all 0.3s ease;\n}\n\n.admin-edit-exercise .large-input {\n  padding: 15px;\n  height: 150px;\n  border: 1px solid #ddd;\n  border-radius: 15px;\n  font-size: 16px;\n  font-family: 'Rubik', sans-serif;\n  width: 100%;\n  box-sizing: border-box;\n  background-color: #f9f9f9;\n  transition: all 0.3s ease;\n  resize: vertical;\n}\n\n.admin-edit-exercise input:focus,\n.admin-edit-exercise textarea:focus {\n  border-color: #A5D6A7;\n  outline: none;\n  background-color: #ffffff;\n  box-shadow: 0px 0px 8px rgba(76, 175, 80, 0.5);\n}\n\n.button-group {\n  display: flex;\n  justify-content: center;\n  gap: 0px;\n  margin-top: 20px;\n}\n\n.admin-edit-exercise button {\n  background: #004D40;\n  color: #fff;\n  border: none;\n  padding: 12px 20px; \n  border-radius: 15px;\n  font-size: 18px; \n  font-family: 'Rubik', sans-serif;\n  cursor: pointer;\n  font-weight: 600;\n  width: 30%;\n  min-width: 160px; \n  margin: 0; \n  transition: all 0.3s ease;\n  height: 52px; \n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.admin-edit-exercise button:hover {\n  background: #2E7D32;\n}\n\n.admin-edit-exercise .cancel-btn3 {\n  background: #dc3545;\n  color: white;\n  width: 30% !important;\n  margin-top: 15px;\n}\n\n.admin-edit-exercise .cancel-btn3:hover {\n  background: #c82333;\n}\n\n.success-message-container {\n  position: fixed;\n  top: 70px;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  pointer-events: none;\n}\n\n.success-message15 {\n  color: #155724;\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  padding: 12px 20px;\n  border-radius: 15px;\n  font-weight: 600;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  display: inline-flex;\n  align-items: center;\n  max-width: 60% !important;\n  text-align: center;\n  animation: fadeInOut 3s ease-in-out forwards;\n}\n\n.error-message15 {\n  color: #d32f2f;\n  background-color: #fde7e9;\n  border: 1px solid #d32f2f;\n  padding: 12px;\n  border-radius: 10px;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px;\n  margin: 10px auto !important; \n  font-weight: 600;\n  width: 40%;\n  justify-content: center !important;\n  text-align: center;\n}\n\n@keyframes fadeInOut {\n  0% { opacity: 0; transform: translateY(-20px); }\n  10% { opacity: 1; transform: translateY(0); }\n  90% { opacity: 1; transform: translateY(0); }\n  100% { opacity: 0; transform: translateY(-20px); }\n}\n\n@media (max-width: 768px) {\n  .admin-edit-exercise {\n    padding: 20px;\n    max-width: 90%;\n  }\n\n  .admin-edit-exercise h1 {\n    font-size: 24px;\n  }\n\n  .button-group {\n    flex-direction: column;\n  }\n\n  .admin-edit-exercise button {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
